import { Dialog, DialogActions, DialogContent, DialogTitle, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import { DateRange } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import StyledButton from "../dashboard/StyledButton";
import { FilterData } from "./types";
import "./styles/DatePicker.css";
import { TransactionDateRangePickerStyles } from "./styles/TransactionDateRangePickerStyles.styles";

interface datePickerProps {
  fullWidth?: boolean;
  style?: any;
  mobile?: boolean;
  setFilterData?: React.Dispatch<React.SetStateAction<FilterData>>;
  setReportsFilter?: React.Dispatch<React.SetStateAction<FilterData>>;
  filterData?: FilterData;
  minimalIcon?: boolean;
  openCalendar?: boolean;
  setOpenCalendar?: React.Dispatch<React.SetStateAction<boolean>>;
  callback?: (start: number, end: number) => void;
}
export default function TransactionDateRangePicker(props: datePickerProps) {
  const [open, setOpen] = React.useState(false);
  const classes = TransactionDateRangePickerStyles();
  const theme = useTheme();
  const [date, setDate] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  useEffect(() => {
    if (props.openCalendar) {
      setOpen(props.openCalendar); // Opens custom click
    }
  }, [props.openCalendar]);

  const handleClose = () => {
    if (props.setOpenCalendar) props.setOpenCalendar(false); // Closes custom click
    setOpen(false);
  };

  function handleSelect(ranges: any) {
    setDate([ranges.selection]);
  }

  const onConfirmFilter = () => {
    const startDate = new Date(date[0].startDate).getTime();
    const endDate = new Date(date[0].endDate).getTime();
    if (props.setReportsFilter) {
      props.setReportsFilter((prev: any): any => ({
        ...prev,
        startDate,
        endDate,
        page: 1,
      }));
    }

    if (props.callback) props.callback(startDate, endDate);
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        sx={{
          minWidth: "400px",
          left: { sm: "calc(100vw - 103%)", md: "calc(100vw - 90%)" },
          height: "106%",
        }}>
        <DialogTitle className={classes.title} id="alert-dialog-title">
          {"Choose Dates"}
        </DialogTitle>
        <DialogContent className={classes.dialogContent}>
          <DateRange
            onChange={handleSelect}
            moveRangeOnFirstSelection={false}
            ranges={date}
            maxDate={new Date()}
            rangeColors={[theme.palette.secondary.main]}
            className={classes.dateRangeWrapper}
          />
        </DialogContent>
        <DialogActions onClick={handleClose} className={classes.button}>
          <StyledButton onClick={onConfirmFilter}>Apply Dates</StyledButton>
        </DialogActions>
      </Dialog>
    </>
  );
}
